import React from 'react';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import Typewriter from 'typewriter-effect';
import SocialIcons from '../subComponents/SocialIcons';
import myPic from '../assets/Images/mypic.png';

const transition = { duration: 0.6, ease: [0.43, 0.13, 0.23, 0.96] };

const MainContainer = styled.div`
  background: ${(props) => props.theme.body};
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  position: relative;
  transition: all 0.25s linear;

  h2 {
    font-family: 'Syne', sans-serif;
  }
`;

const Container = styled.div`
  padding: 2rem;

  @media (max-width: 466px) {
    left: 1rem;
    top: 1rem;
  }
`;

const Line = styled(motion.span)`
  height: 2px;
  background-color: ${(props) => props.theme.text};
`;

const CONTACT = styled(NavLink)`
  color: ${(props) => props.theme.text};
  position: absolute;
  top: 0%;
  right: 0%;
  transform: rotate(90deg) translate(-50%, -50%);
  text-decoration: none;
  z-index: 1;

  .ToContact {
    display: flex;
    flex-direction: row;
    align-items: center;
    position: fixed;
  }
  h2 {
    font-size: calc(2rem + 3vw);
  }
`;

const WORK = styled(NavLink)`
  color: ${(props) => props.theme.text};
  position: absolute;
  bottom: 0%;
  left: 0%;
  transform: translate(-50%, -50%) rotate(-90deg);
  text-decoration: none;
  z-index: 1;

  .ToWorks {
    display: flex;
    flex-direction: row;
    align-items: center;
    position: fixed;
  }
  h2 {
    font-size: calc(2rem + 3vw);
  }
`;

const ABOUT = styled(NavLink)`
  position: absolute;
  bottom: 0;
  right: 5%;
  color: ${(props) => props.theme.text};
  text-decoration: none;

  img {
    position: absolute;
    bottom: 0;
    right: 5%;
    width: 40vw;
    height: auto;
  }
  h2 {
    position: relative;
    bottom: -30px;
    right: 10%;
    font-size: calc(3rem + 4vw);
    color: ${(props) => `rgba(${props.theme.textRgba}, 0.1)`};
    z-index: 1;
  }

  @media (max-width: 951px) {
    img {
      width: 50vw;
      height: auto;
    }
  }

  @media (max-width: 600px) {
    img {
      width: 70vw;
      height: auto;
    }
  }
`;

const Hi = styled.h3`
  position: absolute;
  top: 20%;
  left: -1%;
  color: ${(props) => `rgba(${props.theme.textRgba}, 0.1)`};
  font-size: calc(2rem + 4vw);

  @media (max-width: 595px) {
    top: 23%;
  }
`;

const Text = styled.div`
  position: absolute;
  top: 40%;
  left: 10%;
  width: 60vw;
  color: ${(props) => props.theme.text};
  font-size: calc(1rem + 2vw);

  .name {
    background: url('https://64.media.tumblr.com/9fe961aea231bff20e687ae9f9be7f3c/tumblr_pne8cn1Obg1uzwgsuo1_400.gifv');
    background-size: 50%;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  @media (max-width: 667px) {
    top: 30%;
    width: 80vw;
  }

  @media (max-width: 387px) {
    left: 4%;
    top: 28%;
    width: 80vw;
    font-size: 1.4rem;
  }
`;

const Home = () => {
  return (
    <MainContainer>
      <Container>
        <motion.div exit={{ opacity: 0 }} transition={transition}>
          <SocialIcons />
        </motion.div>

        <CONTACT to="/contact">
          <motion.div
            initial={{
              x: -200,
              transition: { type: 'spring', duration: 1.5, delay: 1.7 }
            }}
            animate={{
              x: 0,
              transition: { type: 'spring', duration: 1.5, delay: 1 }
            }}
            exit={{ x: -500, opacity: 0 }}
            transition={transition}
            className="ToContact"
          >
            <Line
              initial={{ width: '1rem' }}
              animate={{ width: '8rem' }}
              transition={{ type: 'spring', duration: 2, delay: 0 }}
            />
            <motion.h2
              whileHover={{ scale: 1.1 }}
              whileTap={{ x: 500 }}
              transition={transition}
            >
              CONTACT.
            </motion.h2>
          </motion.div>
        </CONTACT>

        <WORK to="/work">
          <motion.div
            initial={{
              x: -200,
              transition: { type: 'spring', duration: 1.5, delay: 1.7 }
            }}
            animate={{
              x: 0,
              transition: { type: 'spring', duration: 1.5, delay: 1 }
            }}
            exit={{ x: -500 }}
            transition={transition}
            className="ToWorks"
          >
            <Line
              initial={{ width: '1rem' }}
              animate={{ width: '8rem' }}
              transition={{ type: 'spring', duration: 2, delay: 0 }}
            />
            <motion.h2
              whileHover={{ scale: 1.1 }}
              whileTap={{ x: 500 }}
              transition={transition}
            >
              WORK.
            </motion.h2>
          </motion.div>
        </WORK>

        <ABOUT to="/about">
          <motion.img
            src={myPic}
            alt="About Link"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1, transition: { duration: 2, delay: 0 } }}
            whileHover={{ scale: 1.1 }}
            transition={transition}
          />

          <motion.h2
            initial={{
              y: 200,
              transition: { type: 'spring', duration: 1.5, delay: 0.8 }
            }}
            animate={{
              y: 0,
              transition: { type: 'spring', duration: 1.5, delay: 1 }
            }}
          >
            ABOUT
          </motion.h2>
        </ABOUT>
        <motion.div
          initial={{
            opacity: 0
          }}
          animate={{
            opacity: 1
          }}
          exit={{ opacity: 0 }}
        >
          <Hi>HELLO_</Hi>
        </motion.div>
        <Text>
          <motion.div
            initial={{
              x: -200,
              opacity: 0,
              transition: { type: 'spring', duration: 1.5, delay: 1 }
            }}
            animate={{
              x: 0,
              opacity: 1,
              transition: { type: 'spring', duration: 1.5, delay: 1 }
            }}
            exit={{ x: -500, opacity: 0 }}
            transition={transition}
          >
            <h1>
              I'm <span className="name"> Shane Del</span>
            </h1>

            <Typewriter
              options={{
                strings: [
                  'Frontend Developer',
                  'Web Designer',
                  'Creative Developer'
                ],
                autoStart: true,
                loop: true,
                cursor: '_'
              }}
            />
          </motion.div>
        </Text>
      </Container>
    </MainContainer>
  );
};

export default Home;
